import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { MenuVisita } from '../_models/menu-visita';

@Injectable({
  providedIn: 'root'
})
export class MenuVisitaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/menuVisita/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as MenuVisita[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as MenuVisita[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as MenuVisita ) );
  }

  obtenerPadres() {
    return this.httpClient.get( this.rutServicio + 'getParents' ).pipe( map( res => res as MenuVisita[] ) );
  }

  obtenerHijos( id: string ) {
    return this.httpClient.get( this.rutServicio + 'obtenerHijos/menuVisita/' + id ).pipe( map( res => res as any ) );
  }

  crear( regCrear: MenuVisita ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as MenuVisita ) );
  }

  actualizar( regActualizar: MenuVisita ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
